module.exports = __webpack_public_path__ + "img/sign-pad-bg.812d5259.png";